var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "350px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.close.apply(null, arguments)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _vm.readonly
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.label,
                      readonly: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.text,
                      callback: function ($$v) {
                        _vm.text = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "text",
                    },
                  })
                : _c(
                    "v-text-field",
                    _vm._g(
                      {
                        attrs: {
                          label: _vm.label,
                          readonly: "",
                          "hide-details": "",
                          clearable: "",
                        },
                        on: { "click:clear": _vm.clear },
                        model: {
                          value: _vm.text,
                          callback: function ($$v) {
                            _vm.text =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "text",
                        },
                      },
                      on
                    )
                  ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title"),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("r-item-kind-dropdown", {
                        attrs: { model: _vm.value.kind },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.value, "kind", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Level:",
                          items: _vm.levels,
                          "menu-props": { maxHeight: "200px" },
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.value.level,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "level", $$v)
                          },
                          expression: "value.level",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.close },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }